import travelClient from './travelClient';
import { travelEndpoints } from './endpoints';
import { normalizeCursorDateTime } from '../features/pagination/cursorDateTime';

function parseSocialNotificationJson(raw) {
  if (typeof raw !== 'string' || !raw) return raw;
  const text = raw.replace(
    /("(?:notificationId|nextCursorNotificationId|targetId|secondaryTargetId|memberId|primaryId|secondaryId)"\s*:\s*)(\d{15,})/g,
    '$1"$2"',
  );
  return JSON.parse(text);
}

const snowflakeJson = { transformResponse: [parseSocialNotificationJson] };

function listConfig(cursor = {}) {
  const params = {};
  if (cursor.limit != null) params.limit = cursor.limit;
  const cursorCreateTime = normalizeCursorDateTime(cursor.cursorCreateTime);
  if (cursorCreateTime && cursor.cursorNotificationId) {
    params.cursorCreateTime = cursorCreateTime;
    params.cursorNotificationId = String(cursor.cursorNotificationId);
  }
  return { ...snowflakeJson, params };
}

export const socialNotificationApi = {
  list: (cursor) => travelClient.get(travelEndpoints.meNotifications, listConfig(cursor)),
  getUnreadCount: () => travelClient.get(travelEndpoints.meNotificationsUnreadCount, snowflakeJson),
  markRead: (notificationId) => travelClient.post(
    travelEndpoints.meNotificationRead(notificationId),
    {},
    snowflakeJson,
  ),
  markAllRead: () => travelClient.post(travelEndpoints.meNotificationsReadAll, {}, snowflakeJson),
};
